import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSessionStore } from "../store/useSessionStore";

const SUPPORTED_LANGUAGES = ["en", "es", "fr"];

/**
 * Re-applies the persisted session language to i18n on mount so the claimed
 * link language wins over the browser language after a refresh.
 */
export function useLanguageSync() {
  const { i18n } = useTranslation();
  const sessionLanguage = useSessionStore(
    (state) => state.session.data?.language
  );

  useEffect(() => {
    if (
      sessionLanguage &&
      SUPPORTED_LANGUAGES.includes(sessionLanguage) &&
      i18n.language !== sessionLanguage
    ) {
      i18n.changeLanguage(sessionLanguage);
    }
  }, [sessionLanguage, i18n]);
}
